<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Lịch sử thao tác"
        :total="total"
        :size="'small'"
        :disabled="loading"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter />
        <CardList
          :data="data"
          :accounts="accounts"
          :document-data="documentData"
          :loading="loading"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";

import logServices from "@/services/log";
import commonServices from "@/services/common";
import organizationServices from "@/services/organization";
import accountServices from "@/services/account";

import constants from "@/config/constants";
import { accountPer } from "@/utils/permission";

export default {
  name: "Logs",
  components: {
    CardHeader,
    CardFilter,
    CardList,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: constants.PAGE_SIZE,
      total: 0,
      data: [],
      documentData: [],
      accounts: [],
      selectedItem: null,
      formVisible: false,
      organizationId: organizationServices.getCurrentOrg()?.id,
      accountPer: accountPer()
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        sort: "-created",
        filters: {
          organization_id: this.organizationId,
          action: { $in: constants.DOCUMENT_TYPE_ACTION_METHODS.map((m) => m.key) }
        }
      };
      if (this.searchText) {
        _params.filters[`name`] = { $regex: this.searchText }
      }
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    async listData() {
      this.loading = true;
      logServices
        .list(this.params)
        .then(async (response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            object_type: item.log_data.model.model_type || item.log_data.payload.type || item.log_data.model.type,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          await this.listDocumentData(this.data)
          this.total = response.meta.total;
          if (this.accountPer.READ) {
            await this.listAllAccounts();
          }
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    getObjectType(objectType) {
      if (objectType !== 'tags') {
        return this.allConfigs.find((c) => c.extra.key === objectType)?.type
      }
      return objectType
    },
    async listDocumentData(data) {
      const documents = data.map((d) => ({
        id: d.log_data.model.id,
        type: this.getObjectType(d.object_type)
      }))
      const payloads = constants.OBJECT_TYPES.map((t) => ({
        type: t.value,
        ids: [...new Set(documents.filter((d) => t.value === d.type).map((d) => d.id))]
      })).filter((p) => p.ids.length > 0);
      const requests = payloads.map((p) => commonServices.list(p.type, {
        offset: 0,
        limit: p.ids.length,
        locale: "vi",
        filters: {
          id: { $in: p.ids },
        }
      }))
      await Promise.all(requests).then((responses) => {
        this.documentData = (responses.map((response) => response.items).flat());
      })
    },
    async listAllAccounts() {
      await accountServices.list({
        offset: 0,
        limit: 999,
        locale: "vi",
        organization_id: this.organizationId,
      }).then((response) => {
        this.accounts = response.items.map((i) => ({
          id: i.id,
          email: i.email
        }))
      })
    },
    handleSearch() {
      this.page = 1;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
  },
};
</script>

<style lang="scss"></style>
